import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatterFileType } from '@models/matter';
import { TestHooks } from './matter-type-icon.hooks';

@Component({
	selector: 'app-matter-type-icon',
	templateUrl: './matter-type-icon.component.html',
	styleUrls: ['./matter-type-icon.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class MatterTypeIconComponent {
	testHooks = TestHooks;
	@Input() fileType: MatterFileType;
}
